import { ProviderServiceModel } from '../../../data/entities';
import { ProviderServiceDetailsPage } from '../';
import { sharedProperty} from '../../../hooks';
import { SlideOutModal, SlideOutModalProps } from '../../../components';

interface ManageProviderServiceModalProps extends SlideOutModalProps {
  dataItemState: sharedProperty<ProviderServiceModel>;
  showState: sharedProperty<boolean>;
  onSubmit: any;
}

export function ManageProviderServiceModal(props: Readonly<ManageProviderServiceModalProps>) {

  return (
    <SlideOutModal {...props}
      title={`${props.dataItemState.value.service?.name}`}
      bodyClassName="p-0"
    >
      <ProviderServiceDetailsPage dataItemState={props.dataItemState} showState={props.showState} onSubmit={props.onSubmit} />
      {props.children}
    </SlideOutModal>
  )
}

export default ManageProviderServiceModal;
